/**
 * @module AlgoliaRoboshots
 * @description Initializes and manages Algolia product search grid for ROBOSHOTs.
 */

import { createProductSearchGrid } from './BaseProductSearchGrid.js';
import { createProductConfig } from '@js/algolia/createProductConfig.js';
import { roboshotsConfig } from '@js/config/algolia.js';

function getSpecs(result, translations = {}) {
  const specs = [];
  const maxInjectionSpeedLabel =
    translations.maxInjectionSpeed || 'Max. Injection Speed';

  if (result.screwDiameterDisplay) {
    specs.push({
      label: 'Screw Diameter',
      value: result.screwDiameterDisplay,
    });
  }

  if (result.tieBarSpacingDisplay) {
    specs.push({
      label: 'Tie Bar Spacing, H×V',
      value: result.tieBarSpacingDisplay,
    });
  }

  if (result.tonnageDisplay) {
    specs.push({
      label: 'Tonnage',
      value: result.tonnageDisplay,
    });
  }

  if (result.maxInjectionSpeedDisplay) {
    specs.push({
      label: maxInjectionSpeedLabel,
      value: result.maxInjectionSpeedDisplay,
    });
  }

  return specs;
}

function hasSpecs(result) {
  return !!(
    result.tonnageDisplay ||
    result.screwDiameterDisplay ||
    result.tieBarSpacingDisplay ||
    result.maxInjectionSpeedDisplay
  );
}

function formatCardData(result, translations) {
  return {
    heading: result.title || '',
    url: result.absoluteUri || result.url || '#',
    image: result.productImage || null,
    category:
      result.productSeries && result.productSeries.length
        ? result.productSeries[0]
        : null,
    description: result.description || result.tagline || null,
    attributes: getSpecs(result, translations).map((spec, i) => ({
      icon: ['screw-diameter', 'tie-bar-spacing', 'tonnage'][i] ?? null,
      label: spec.label,
      value: spec.value,
    })),
    legacy: result.legacy || false,
  };
}

export default createProductSearchGrid({
  appId: roboshotsConfig.app_id,
  apiKey: roboshotsConfig.api_key,
  indexName: roboshotsConfig.index,
  configureWidget: createProductConfig('[data-search-roboshots]'),
  formatCardData,
  getSpecs,
  hasSpecs,
  scrollToSelector: '[data-search-roboshots]',
});
